import lrSpinner from './_src/lrSpinner.vue'

lrSpinner.install = function(Vue) {
  Vue.component(lrSpinner.name, lrSpinner)
}

export default lrSpinner
